import StartShell from "../../../routes/start/StartShell";
import { useScratchWizard, STEP_NAMES } from "./useScratchWizard";
import {
  StepAbout, StepBasics, StepCapabilities, StepContact,
  StepInspiration, StepIntegrations, StepMedia, StepReview,
} from "./steps";

export default function BuildFromScratch() {
  const w = useScratchWizard();
  const { step, setStep } = w;

  return (
    <StartShell
      title="Build from scratch"
      subtitle={`Step ${step} of 8 — ${STEP_NAMES[step - 1]}`}
      step={{ current: step, total: 8 }}
    >
      {step === 1 && (
        <StepAbout type={w.type} setType={w.setType} canStep1={w.canStep1} setStep={setStep} />
      )}
      {step === 2 && (
        <StepBasics
          type={w.type} name={w.name} setName={w.setName} tagline={w.tagline} setTagline={w.setTagline}
          description={w.description} setDescription={w.setDescription} onboardingError={w.onboardingError}
          canStep2={w.canStep2} setStep={setStep}
        />
      )}
      {step === 3 && (
        <StepContact
          address={w.address} setAddress={w.setAddress} phone={w.phone} setPhone={w.setPhone}
          email={w.email} setEmail={w.setEmail} hours={w.hours} setHour={w.setHour}
          canStep3={w.canStep3} setStep={setStep}
        />
      )}
      {step === 4 && (
        <StepCapabilities capIds={w.capIds} toggleCap={w.toggleCap} canStep4={w.canStep4} setStep={setStep} />
      )}
      {step === 5 && (
        <StepIntegrations
          type={w.type} integrationIds={w.integrationIds} toggleIntegration={w.toggleIntegration}
          canStep5={w.canStep5} setStep={setStep}
        />
      )}
      {step === 6 && (
        <StepInspiration
          motion={w.motion} setMotion={w.setMotion}
          inspoUrls={w.inspoUrls} inspoPreviews={w.inspoPreviews}
          setInspo={w.setInspo} addInspoRow={w.addInspoRow} removeInspoRow={w.removeInspoRow}
          canStep6={w.canStep6} setStep={setStep}
        />
      )}
      {step === 7 && (
        <StepMedia
          ownerNote={w.ownerNote} setOwnerNote={w.setOwnerNote} attachments={w.attachments}
          logoPreview={w.logoPreview} setLogoPreview={w.setLogoPreview}
          uploading={w.uploading} uploadProgress={w.uploadProgress} uploadErr={w.uploadErr}
          dismissUploadError={w.dismissUploadError}
          zipSkipped={w.zipSkipped}
          logoInputRef={w.logoInputRef} photosInputRef={w.photosInputRef} zipInputRef={w.zipInputRef}
          handleLogoPick={w.handleLogoPick} handlePhotosPick={w.handlePhotosPick} handleZipPick={w.handleZipPick}
          removeAttachment={w.removeAttachment} canStep7={w.canStep7} setStep={setStep}
        />
      )}
      {step === 8 && (
        <StepReview
          type={w.type} name={w.name} tagline={w.tagline} description={w.description}
          address={w.address} phone={w.phone} email={w.email} hours={w.hours}
          capIds={w.capIds} integrationIds={w.integrationIds} inspoUrls={w.inspoUrls}
          ownerNote={w.ownerNote} attachments={w.attachments} logoPreview={w.logoPreview}
          subdomain={w.subdomain} setSubdomain={w.setSubdomain} setSubdomainTouched={w.setSubdomainTouched}
          subCheck={w.subCheck} submitting={w.submitting} submitErr={w.submitErr} submitFixStep={w.submitFixStep}
          canSubmit={w.canSubmit} handleSubmit={w.handleSubmit} setStep={setStep}
        />
      )}
    </StartShell>
  );
}
